import {
  combineReducers,
  configureStore,
  ThunkAction,
  UnknownAction
} from '@reduxjs/toolkit'
import { domainApiMiddlewares, domainReducers } from '../domains'
import { moduleApiMiddlewares, moduleReducers } from '../modules'

export const rootReducer = combineReducers({
  ...domainReducers,
  ...moduleReducers
})

export type RootState = ReturnType<typeof rootReducer>

export const getStore = (preloadedState: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    devTools: {
      name: 'Sportable',
      trace: true,
      traceLimit: 25
    },
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false
      }).concat(...moduleApiMiddlewares, ...domainApiMiddlewares)
  })
}

export const store = getStore({})

export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  UnknownAction
>
